"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var textarea_autosize_1 = require("./subcomponents/textarea_autosize");
var propTypes = {
    error: PropTypes.bool
};
/**
 * The `Textarea` component is wrapper of the HTML textarea element. A textarea
 * should only be used within a [FormRow component](#!/FormRow) component.
 * The [TextareaRow component](#!/TextareaRow) does provide a shortcut for this
 * combination.
 *
 * The row count of a `Textarea` will be adjusted dynamically depending on the
 * content. The minimum and maximum row counts are defined by the props `minRows`
 * and `maxRows`. A fixed row count (and component height) can be defined by the
 * `rows` prop.
 */
var Textarea = /** @class */ (function (_super) {
    __extends(Textarea, _super);
    function Textarea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Textarea.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, className = _a.className, error = _a.error, minRows = _a.minRows, maxRows = _a.maxRows, rows = _a.rows, other = __rest(_a, ["children", "id", "className", "error", "minRows", "maxRows", "rows"]);
        var componentClassName = classNames(className, 'ee_textarea', {
            'ee_is-invalid': error
        });
        if (typeof rows !== 'undefined') {
            return (React.createElement("textarea", __assign({ id: id, "data-focus-id": id, className: componentClassName, rows: rows }, other, { "aria-invalid": error })));
        }
        else {
            return (React.createElement(textarea_autosize_1.default, __assign({ id: id, "data-focus-id": id, className: componentClassName, minRows: minRows, maxRows: maxRows }, other, { "aria-invalid": error })));
        }
    };
    Textarea.propTypes = propTypes;
    Textarea.defaultProps = {
        error: false,
        minRows: 3,
        maxRows: 10,
        rows: undefined
    };
    return Textarea;
}(react_1.Component));
exports.Textarea = Textarea;
exports.default = Textarea;
//# sourceMappingURL=Textarea.js.map